export const ErrorDataIcon = ({ className }: { className: string }) => (
<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_5098_3153)">
<path d="M22 44C34.1503 44 44 34.1503 44 22C44 9.84974 34.1503 0 22 0C9.84974 0 0 9.84974 0 22C0 34.1503 9.84974 44 22 44Z" fill="#E15E64"/>
<path d="M36.2372 32.2929H7.76291C7.37005 32.2929 7.02434 32.0886 6.83576 31.7586C6.64719 31.4286 6.64719 31.02 6.83576 30.69L21.0729 6.03429C21.2615 5.70429 21.6229 5.5 22 5.5C22.3929 5.5 22.7386 5.70429 22.9272 6.03429L37.1643 30.69C37.3529 31.02 37.3529 31.4286 37.1643 31.7586C36.9758 32.0886 36.6143 32.2929 36.2372 32.2929ZM21.5915 6.33286L7.35434 30.9886C7.27576 31.1457 7.26005 31.3186 7.35434 31.46C7.43291 31.6171 7.59005 31.6957 7.76291 31.6957H36.2372C36.41 31.6957 36.5672 31.6014 36.6458 31.46C36.7243 31.3186 36.7243 31.13 36.6458 30.9886L22.4086 6.33286C22.33 6.17571 22.1729 6.09714 22 6.09714C21.8272 6.09714 21.67 6.19143 21.5915 6.33286Z" fill="white"/>
<path d="M22 28.0029C21.4657 28.0029 21.0729 27.5943 21.0729 27.0286C21.0729 26.4629 21.4657 26.0386 22 26.0386C22.5343 26.0386 22.9272 26.4314 22.9272 27.0286C22.9272 27.6257 22.55 28.0029 22 28.0029Z" fill="white"/>
<path d="M21.4186 24.9386L21.12 14.8186H22.88L22.5814 24.9386H21.4186Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_5098_3153">
<rect width="44" height="44" fill="white"/>
</clipPath>
</defs>
</svg>


);
